export const UNASSIGNED_BOXES_FEATURE_KEY = 'unassigned-boxes';
